export default __webpack_public_path__ + "static/media/icons8-react-native.83c4f89e.gif";